import React from 'react';

import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import './index.scss';
import "./components/common/index.scss";
import Header from "./components/new_header"

import toast from "./utils/toast";
import axios from "axios";

// Import custom components
import store from './store';
import { getAllProducts, retrieveCartFromServer, mergeCartFromServer } from './actions'
import Routes from './routes';

// Restore axios auth headers from localStorage on page load
if (localStorage.getItem("token")) {
    axios.defaults.headers.common["Authorization"] = "Bearer " + localStorage.getItem("token");
    axios.defaults.headers.common["api_token"] = localStorage.getItem("api_token");
    axios.defaults.headers.common["user_id"] = localStorage.getItem("user_id");
    axios.defaults.headers.common["user_type"] = localStorage.getItem("user_type");
}

class Root extends React.Component {

    constructor() {
        super();
        /* LIVE mode */
        // global.postUrl = 'https://sunnydiamonds.com/api/api/';
        // global.rzpKey = 'rzp_live_CPpNWhC0ODrQeV';
        // global.rzpCallbk = 'https://sunnydiamonds.com/api/api/razorpay/response';
        // global.rzpCancel = 'https://sunnydiamonds.com/api/api/razorpay/cancel';
        // global.publicUrl = 'https://sunnydiamonds.com/';
        // global.reCaptcha = '6LeqaKUfAAAAAJ1RJspvJAojvMjcGi11E3UsMTnF';
        // global.rzpGiftCallbk = 'https://sunnydiamonds.com/api/api/giftcards/purchase/confirm';
        // global.rzpGiftCancel = 'https://sunnydiamonds.com/api/api/giftcards/purchase/cancel';
        //for assets 
        // global.webdisk = 'https://sprdigitallab.com/sdwebdisk/'

        /* STAGING mode - loaded from environment variables */
        global.postUrl = process.env.REACT_APP_POST_URL;
        global.rzpKey = process.env.REACT_APP_RZP_KEY;
        global.rzpCallbk = process.env.REACT_APP_RZP_CALLBACK;
        global.rzpCancel = process.env.REACT_APP_RZP_CANCEL;
        global.publicUrl = process.env.REACT_APP_PUBLIC_URL;
        global.reCaptcha = process.env.REACT_APP_RECAPTCHA;
        global.rzpGiftCallbk = process.env.REACT_APP_RZP_GIFT_CALLBACK;
        global.rzpGiftCancel = process.env.REACT_APP_RZP_GIFT_CANCEL;
        //for assets
        global.webdisk = process.env.REACT_APP_WEBDISK;

        // global.postUrl = 'https://sd.sunnydiamonds.com/api/api/';
        // global.rzpKey = 'rzp_test_S60EC1J0KuQfuX';
        // global.rzpCallbk = 'https://sd.sunnydiamonds.com/api/api/razorpay/response';
        // global.rzpCancel = 'https://sd.sunnydiamonds.com/api/api/razorpay/cancel';
        // global.publicUrl = 'https://sd.sunnydiamonds.com/';
        // global.reCaptcha = '6LdG_wAgAAAAAJtwvnhJaCPTEpDLXVSdCflRuC0V';
        // global.rzpGiftCallbk = 'https://sd.sunnydiamonds.com/api/api/giftcards/purchase/confirm';
        // global.rzpGiftCancel = 'https://sd.sunnydiamonds.com/api/api/giftcards/purchase/cancel';
        // //for assets 
        // global.webdisk = 'https://sprdigitallab.com/sdstagingwebdisk/'

        // Algolia credentials from environment (object created in public/assets/js/runtime.js)
        window.rc.algoliasearch.appId = process.env.REACT_APP_ALGOLIA_APP_ID;
        window.rc.algoliasearch.apiKey = process.env.REACT_APP_ALGOLIA_API_KEY;
        // window.rc.algoliasearch.appId = "DS5IPOMZVR";
        // window.rc.algoliasearch.apiKey = "3624306bea970d0b01da567f22ef6e09";

        /* LOCAL mode */
        /* global.postUrl = 'http://192.168.1.17:8080/api/';
        global.rzpKey = 'rzp_test_O6CaPqbNbFTaEJ';
        global.rzpCallbk = 'http://192.168.1.17:8080/razorpay/response';
        global.rzpCancel = 'http://192.168.1.17:8080/razorpay/cancel';
        global.publicUrl = 'http://localhost:3000/';
        global.reCaptcha = '6LdG_wAgAAAAAJtwvnhJaCPTEpDLXVSdCflRuC0V';
        global.rzpGiftCallbk = 'http://192.168.1.17:8080/giftcards/purchase/confirm';
        global.rzpGiftCancel = 'http://192.168.1.17:8080/giftcards/purchase/cancel';
        // //for assets 
        global.webdisk = 'https://static.sunnydiamonds.com/images/' */
    }

    componentDidMount() {
        const disableNativeValidation = (root = document) => {
            const forms = root.querySelectorAll("form");
            forms.forEach((form) => {
                form.setAttribute("novalidate", "");
                form.noValidate = true;
            });
        };

        disableNativeValidation();
        this.validationObserver = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                mutation.addedNodes.forEach((node) => {
                    if (node.nodeType !== 1) return;
                    if (node.tagName === "FORM") {
                        node.setAttribute("novalidate", "");
                        node.noValidate = true;
                    } else if (node.querySelectorAll) {
                        disableNativeValidation(node);
                    }
                });
            });
        });
        this.validationObserver.observe(document.body, {
            childList: true,
            subtree: true,
        });

        const queryParams = new URLSearchParams(window.location.search);
        const t = queryParams.get('t');
        const c = queryParams.get('c');
        if (t == 1) {
            if (c == 1)
                toast.success("Successfully Subscribed", { toastId: "subscribe-success" })
            else if (c == 2)
                toast.success("Successfully Unsubscribed", { toastId: "unsubscribe-success" })
            queryParams.delete('t');
            queryParams.delete('c');
            window.history.replaceState({}, "", window.location.pathname + "?" + queryParams.toString());
        }
        store.dispatch({ type: "SORT_BY", sort_by: "LowToHigh" })

        // Retrieve the user's saved cart from the server on every page load
        // when logged in, so it stays in sync across browsers/devices.
        if (
            localStorage.getItem("token") &&
            localStorage.getItem("user_type") === "CUSTOMER"
        ) {
            if (localStorage.getItem("merge_cart_on_login")) {
                // Just logged in: merge the guest cart into this user, then
                // retrieve the unified cart. One-shot — clear the flag.
                localStorage.removeItem("merge_cart_on_login");
                store.dispatch(mergeCartFromServer());
            } else {
                // Always pull the server cart on refresh so a logged-in user
                // stays in sync across browsers/devices (server is the source
                // of truth — local adds already push via addCartToServer).
                // Replaces local cart even if the server returns empty.
                store.dispatch(retrieveCartFromServer());
            }
        }
    }

    componentWillUnmount() {
        if (this.validationObserver) {
            this.validationObserver.disconnect();
        }
    }

    render() {
        store.dispatch(getAllProducts());
        return (
            <Provider store={store}>
                <Routes />
            </Provider>
        );
    }
}

const rootEl = document.getElementById('root');
rootEl.classList.remove('height');
ReactDOM.render(<Root />, rootEl);
